import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl, tablet_s } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar } from '../../global/commonStyle';

const Main = styled.div`
  padding-inline: var(--space-24);
  height: 100dvh;
  position: relative;
  ${HideScrollbar}
  ${mobile_xl(css`
    padding-inline: var(--space-20);
  `)}
`;

const SnapHeader = styled.div`
  ${FlexBetween}
  padding-block: var(--space-14);
  position: sticky;
  top: 0;
  z-index: var(--z-index-header);
  margin-right: -2px;
  background: var(--background-secondary);
  .ant-dropdown {
    width: 100%;
    max-width: 260px;
  }
  ${mobile_xl(css`
    padding-block: var(--space-12);
  `)}
`;

const LeftSide = styled.div`
  ${FlexCenter}
  gap: var(--space-12);
`;

const RightSide = styled.div``;

const Icon = styled.div`
  width: 28px;
  height: 28px;
`;

const Heading = styled.div`
  ${Typography.heading_lg}
  color: var(--text-primary);
`;
const Snaps = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(174px, 1fr));
  grid-template-rows: auto;
  gap: var(--space-24);
  margin-bottom: var(--space-24);
  ${tablet_s(css`
    grid-template-columns: repeat(auto-fill, minmax(154px, 1fr));
  `)}
  ${mobile_xl(css`
    margin-block: var(--space-8) var(--space-96);
  `)}
`;

const HeaderTitle = styled.div`
  ${mobile_xl(css`
    ${AlignCenter}
    gap: var(--space-24);
  `)}
`;
export { Main, SnapHeader, LeftSide, RightSide, Icon, Heading, Snaps, HeaderTitle };
